<template>
  <div v-if="flagDisplayBar">


      <h6 class="text-gray" style="font-size:12px">{{barData.Label}}</h6>
      <div v-if="buttonDisplayColor==1">
        <div class="progress">
            <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: actualBarWidth}">{{displayValue}} {{barData.AfterText}} </div>
        </div>
      </div>

      <div v-if="buttonDisplayColor==2">
        <div class="progress">
            <div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: actualBarWidth}">{{displayValue}} {{barData.AfterText}} </div>
        </div>
      </div>

      <div v-if="buttonDisplayColor==3">
        <div class="progress">
            <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" v-bind:style="{width: actualBarWidth}">{{displayValue}} {{barData.AfterText}} </div>
        </div>
      </div>

  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters} from 'vuex'

export default {
  props: ['barData'], //{PreviousText, Value, Max, AfterText}

  data() {
    return {
      tempoBundle : {},
      actualBarWidth : '',
      actualPourcentage : 0,
      displayValue : 0,
      flagDisplayBar : true,
      buttonDisplayColor : 1, //1 : Success, 2: Warning, 3:Danger
    }
  },
  computed: {
    ...mapState('sessionStore', ['actualBundleChannelMaximums']),
  },
  watch: {
    actualBundleChannelMaximums(){
      this.computeColorDisplay()
    },


  },
  methods: {
  
   computeColorDisplay(){
      this.flagDisplayBar = false
      this.buttonDisplayColor = 1
      this.displayValue = this.barData.Value.toFixed(2)
      if (this.barData.Value > 0.70*this.barData.Max){this.buttonDisplayColor = 2}
      if (this.barData.Value > 0.9*this.barData.Max){this.buttonDisplayColor = 3}

      this.actualPourcentage = 100*this.barData.Value/this.barData.Max
      this.actualBarWidth = ''
      this.actualBarWidth = this.actualBarWidth.concat((100*this.barData.Value/this.barData.Max),'%')
      this.flagDisplayBar = true

      },


    },



  mounted() {
    this.computeColorDisplay()

  },



}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// RelativePowerBar.vue?34dba976